import { useMemo } from 'react';

import { EventJournalQueries } from '@entities/eventJournal/model/queries';
import { TAuthor } from '@entities/eventJournal/model/types';
import { useFilterQuery, useGetFilterNames } from '@features/JournalEventsFilters/lib';
import { TFilterItem } from '@features/JournalEventsFilters/model/types';

export const useFilterByAuthor = ({ authorsData }: { authorsData: TAuthor[] }) => {
    const defaultValues = useGetFilterNames({
        filterData: authorsData,
        queryKey: EventJournalQueries.authors,
    });
    const { onFilterClickQuery, clearQueryValue } = useFilterQuery({
        queryKey: EventJournalQueries.authors,
    });

    const data: TFilterItem[] = useMemo(() => {
        const list = authorsData ?? [];
        const selected = new Set(defaultValues ?? []);

        return list.map<TFilterItem>((item) => ({
            label: item.name,
            value: String(item.id),
            isChecked: selected.has(String(item.name)),
            imgUrl: item.avatarUrl,
            type: item.type,
        }));
    }, [authorsData, defaultValues]);

    const onAuthorClick = (value: string) => {
        onFilterClickQuery(value);
    };
    const onClearValuesCb = () => {
        void clearQueryValue();
    };

    return {
        data,
        defaultValues,
        onAuthorClick,
        onClearValuesCb,
    };
};
